import { request } from '@langlois/request';

export async function getMemberships ({ commit }, clubId) {
	try {
		const url = new URL(`${process.env.VUE_APP_API_URI}/club/club/${clubId}/membership`);

		const response = await request.get(url);

		if (response.ok) {
			const memberships = await response.json();

			return commit(`setMemberships`, {
				memberships
			});
		}

		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the memberships.`,
			type: `warning`
		}, { root: true });
	} catch (error) {
		return commit(`vcl/notificationBar/show`, {
			text: `Encountered an error while retrieving the memberships.`,
			type: `warning`
		}, { root: true });
	}
}
